import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { ComingSoonPlaceholder } from "../../../shared/components/placeholders/ComingSoonPlaceholder"
import { ExternalLink } from "../../../shared/components/links/ExternalLink"

const BESTIL_NU_URL = "https://bestil-nu.net"

export function CompanyComingSoonPlaceholder() {
    return (
        <LocalizedStrict id="company-home-coming-soon-placeholder" attrs={{ title: true }}>
            <ComingSoonPlaceholder
                title="Coming soon"
                body={
                    <LocalizedStrict
                        id="company-home-coming-soon-placeholder-body"
                        elems={{ externalLink: <ExternalLink href={BESTIL_NU_URL} /> }}
                    >
                        <span>
                            You are logged in as a company administrator. We are working to bring you this feature. For
                            now, please use <ExternalLink href={BESTIL_NU_URL}>bestil-nu.net</ExternalLink>.
                        </span>
                    </LocalizedStrict>
                }
            />
        </LocalizedStrict>
    )
}
